"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInitializeMarketInstruction = void 0;
const utils_1 = require("../utils");
/**
 * Returns an instruction which initializes a market with a specified update authority
 *
 * @param connection
 * @param updateAuthorityAccount - Public key of account which will be set as the marketplace's upddate authority
 * @param programId - Deployed program ID for GM program
 */
function createInitializeMarketInstruction({ connection, updateAuthorityAccount, programId, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const program = (0, utils_1.getMarketplaceProgram)({ connection, programId });
        const instructions = [
            yield program.methods
                .initializeMarketplace()
                .accounts({ updateAuthorityAccount })
                .instruction(),
        ];
        return {
            accounts: [],
            instructions,
        };
    });
}
exports.createInitializeMarketInstruction = createInitializeMarketInstruction;
//# sourceMappingURL=initializeMarketplace.js.map